<template>
  <div class="viewport viewport-failed container">
    <div class="age-check-failed-container">
      <div class="logo-container">
        <img :src="logo" alt="logo" class="logo" />
      </div>
      <div class="lower-container">
        <div class="failed-header">
          {{ $t("exit.claim") }}
        </div>
        <div class="failed-content">
          {{ $t("exit.claim_text") }}
        </div>
        <div class="close-button-container">
          <button type="button" class="close-button" @click="handleButtonClick">
            GOT IT
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logo_jaegermeister_white.svg";
import close from "@/assets/images/close.svg";
export default {
  data() {
    return {
      logo: logo,
      close: close,
    };
  },
  methods: {
    handleButtonClick() {
      location.reload();
    },
  },
};
</script>

<style scoped>
.age-check-failed-container {
  text-align: center;
  color: white;
  display: flex;
  flex-direction: column;
  font-family: "Meister-Regular";
  justify-content: space-between;
  margin-top: 6rem;
  align-items: center;
  height: 75dvh;
}

.container-age-gate {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.logo-container {
  margin-bottom: 1rem;
}

.logo {
  width: 100px;
}

.failed-header {
  text-transform: uppercase;
  font-family: "Meister-Bold";
  font-size: 3.4rem;
  line-height: 1;
  margin-bottom: 1rem;
}

/* .failed-subheader {
  font-weight: bold;
  font-size: 4rem;
  line-height: 1;
  margin: 1rem 0;
} */

.failed-content {
  padding: 0 4.25rem;
  font-size: 1.75rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-weight: 300;
}

.close-button-container {
  margin-top: 1rem;
  width: 30rem;
  display: flex;
  justify-content: center;
}

.close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Meister-Bold";
  color: black;
  --tw-bg-opacity: 1;
  background-color: white;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  width: 80vw;
  border: none;
  cursor: pointer;
  border-radius: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
}

.close-icon {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

.lower-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  width: 100%;
}

.viewport {
  background-color: black;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  background-size: cover;
}

.viewport-failed {
  background-image: url("~@/assets/images/Disclaimer.jpg");
  background-color: black;
  background-repeat: no-repeat;
  background-position: right center;
  background-attachment: fixed;
  background-size: cover;
}

.container {
  width: 100%;
  padding: 1rem;
}
</style>
